<div class="ts1-reminder-notes-modal flex h-full flex-col overflow-hidden">
	<div class="dialog-header">
		<div class="text-base font-bold text-black">{{ data.title || "Reminder Notes" }}</div>
	</div>
	<div class="dialog-content flex-1">
		<div class="ts1-reminder-notes-modal__editor">
			<textarea
				[formControl]="remarkControl"
				class="border-bg-grey-20 ts1-reminder-notes-modal__textarea h-[200px] w-full resize-none border p-4"
				[class.ts1-reminder-notes-modal__textarea--with-toolbar]="commentAiAssist"
				[placeholder]="placeholder"
				[attr.maxlength]="getCommentMaxLength()"
			></textarea>
			@if (commentAiAssist) {
				<app-comment-ai-assist-toolbar
					[commentControl]="remarkControl"
					(replace)="save()"
				></app-comment-ai-assist-toolbar>
			}
		</div>
		<p class="mt-1 text-right text-[10px] text-grey-90">
			{{ commentLengthLabel((remarkControl.value ?? "").length) }}
		</p>
	</div>
	<div class="dialog-footer">
		<button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
		<div class="flex-1"></div>
		@if (!usesCommentAiToolbar()) {
			<button type="button" mat-flat-button color="warn" (click)="save()">Save</button>
		}
	</div>
</div>
